import { render, staticRenderFns } from "./DateSelection.vue?vue&type=template&id=22c43464&scoped=true"
import script from "./DateSelection.vue?vue&type=script&lang=js"
export * from "./DateSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c43464",
  null
  
)

export default component.exports